// document.addEventListener('DOMContentLoaded', (event) => {
//   const option1 = document.querySelector('.v-options #swatch-option1 select');
//   const option2 = document.querySelector('.v-options #swatch-option2');
//   const vCustomWrapper = document.querySelector('.v-custom-wrapper');
//   setTimeout(() => {
//      const selectedOption = option1.options[0];
//      selectedOption.selected = true;
  
//      option1.addEventListener('change', (e) => {
//       const selectedOptionIndex = e.target.selectedIndex;
    
//       if (selectedOptionIndex === 1) {
//         option2.style.display = 'none';
//         vCustomWrapper.style.display = 'block';
//       } else {
//         option2.style.display = 'block';
//         vCustomWrapper.style.display = 'none';
//       }
//    });
//  }, 8000);
// });
/*
  window.addEventListener('load', () => {
   var option1 = document.querySelector('.v-options #swatch-option1 select');
   var option2 = document.querySelector('.v-options #swatch-option2');
   var vCustomWrapper = document.querySelector('.v-custom-wrapper');
   var selectedOption = option1.options[0];
   selectedOption.selected = true;

      option1.addEventListener('change', (e) => {
        const selectedOptionIndex = e.target.selectedIndex;

        if (selectedOptionIndex === 1) {
          option2.style.display = 'none';
          vCustomWrapper.style.display = 'block';
        } else {
          option2.style.display = 'block';
          vCustomWrapper.style.display = 'none';
        }
      });
  });
*/




function OrderSizeHelp(title,feeId,prodID)
  {
    var decision = $('.product-variants2.OrderSizeHelp input:checked').val();
    if(decision == 'true')
    {
      // first check if the fee product already exists in the cart
      $.ajax({
        url: "/cart.js",
        type: 'GET',
        dataType: 'json', // added data type
        success: function(res) {
          var allitems = res.items;
          var alreadyexists = false;

        for(i=0; i < allitems.length ; i++)
        {
          if(allitems[i].product_id == prodID){
            alreadyexists = true;
          }
        }
 
          if(!alreadyexists)
          {
          // here it doesn't exists. So adding fee product now

          var dataAll = {
            quantity: 1,
            id: feeId,
            properties: {
              Pour: title
           }  
          }
    
          $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: dataAll,
            dataType: 'json', 
           success: function (data) { 
            
             // now fee added, add main product now
             $('button#mainButton').click();
           } 
           });
            
          }else{
            $('button#mainButton').click();
          }
          
          }
           
      });
  
    }else{
      $('button#mainButton').click();
    }
  }

 